module.exports = __webpack_public_path__ + "img/gcp.e7971776.png";